import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '@helpers/AsyncFunc';
import { useSelector } from 'react-redux';
import { defineUserRoles } from '@helpers/utility';
import StatusMessage from '@page/common/StatusMessage';

const routes = [
  {
    path: '',
    component: asyncComponent(() => import('../dashboard'))
  },
  {
    path: 'radius-profiles/update-domain',
    component: asyncComponent(() => import('@page/radius-profiles/updateDomain')),
  },
  {
    path: 'radius-profiles/:id/edit',
    component: asyncComponent(() => import('@page/radius-profiles/addEdit'))
  },
  {
    path: 'radius-profiles',
    component: asyncComponent(() => import('@page/radius-profiles'))
  },
  {
    path: 'users',
    component: asyncComponent(() => import('@page/users'))
  },
  {
    path: 'users/create',
    component: asyncComponent(() => import('@page/users/addEdit'))
  },
  {
    path: 'users/:userId/edit',
    component: asyncComponent(() => import('@page/users/addEdit'))
  },
  {
    path: 'plans',
    component: asyncComponent(() => import('@page/plans'))
  },
  {
    path: 'plans/create',
    component: asyncComponent(() => import('@page/plans/addEdit'))
  },
  {
    path: 'plans/:planId/edit',
    component: asyncComponent(() => import('@page/plans/addEdit'))
  },
  {
    path: 'plans/:planId/replicate',
    component: asyncComponent(() => import('@page/plans/addEdit'))
  },
  /*
  {
    path: 'plans/promotions',
    component: asyncComponent(() => import('@page/plans/promotions'))
  },
  */
  {
    path: 'groups',
    component: asyncComponent(() => import('@page/groups'))
  },
  {
    path: 'applications',
    component: asyncComponent(() => import('@page/applications'))
  },
  {
    path: 'applications-digi',
    component: asyncComponent(() => import('@page/applications'))
  },
  {
    path: 'applications-celcom',
    component: asyncComponent(() => import('@page/applications'))
  },
  {
    path: 'daisy-failure-tracker',
    component: asyncComponent(() => import('@page/daisy-failure-tracker'))
  },
  {
    path: 'applications/files',
    component: asyncComponent(() => import('@page/applications/file'))
  },
  {
    path: 'applications/create',
    component: asyncComponent(() => import('@page/applications/addEdit'))
  },
  {
    path: 'celcom/create',
    component: asyncComponent(() => import('@page/celcom/addEdit'))
  },
  {
    path: 'applications/:session/edit',
    component: asyncComponent(() => import('@page/applications/addEdit'))
  },
  {
    path: 'celcom/:session/edit',
    component: asyncComponent(() => import('@page/celcom/addEdit'))
  },
  // {
  //   path: 'broadbands',
  //   component: asyncComponent(() => import('@page/broadbands')),
  //   roles: [
  //     'FBB Operations',
  //     // 'Customer Service',
  //     // 'DIGI Store Staff',
  //     // 'DIGI Dealer',
  //     // 'GENEX',
  //     'Admin',
  //     // 'DIGI Store Manager',
  //     'Marketing Ops',
  //     'Performance Analyst',
  //     'Tester'
  //   ]
  // },
  {
    path: 'broadbands/files',
    component: asyncComponent(() => import('@page/broadbands/file'))
  },
  // {
  //   path: 'broadbands/create',
  //   component: asyncComponent(() => import('@page/broadbands/addEdit')),
  //   roles: [
  //     'FBB Operations',
  //     // 'Customer Service',
  //     // 'DIGI Store Staff',
  //     // 'DIGI Dealer',
  //     // 'GENEX',
  //     'Admin',
  //     // 'DIGI Store Manager',
  //     // 'Marketing Ops',
  //     'Tester'
  //   ]
  // },
  // {
  //   path: 'broadbands/:key_id/edit',
  //   component: asyncComponent(() => import('@page/broadbands/addEdit')),
  //   roles: [
  //     'FBB Operations',
  //     // 'Customer Service',
  //     // 'DIGI Store Staff',
  //     // 'DIGI Dealer',
  //     // 'GENEX',
  //     'Admin',
  //     // 'DIGI Store Manager',
  //     'Marketing Ops',
  //     'Tester'
  //   ]
  // },
  {
    path: 'change-plan-request',
    component: asyncComponent(() => import('@page/change-plan-request'))
  },
  {
    path: 'change-plan-request/celcom/add',
    component: asyncComponent(() => import('@page/change-plan-request/celcom-copRequest'))
  },
  {
    path: 'change-plan-request/celcom/:session/edit',
    component: asyncComponent(() => import('@page/change-plan-request/celcom-copRequest'))
  },
  {
    path: 'change-plan-request/digi/add',
    component: asyncComponent(() => import('@page/change-plan-request/digi-copRequest'))
  },
  {
    path: 'change-plan-request/digi/:session/edit',
    component: asyncComponent(() => import('@page/change-plan-request/digi-copRequest'))
  },
  {
    path: 'troubleshooting',
    component: asyncComponent(() => import('@page/troubleshooting'))
  },
  {
    path: 'troubleshooting/details',
    component: asyncComponent(() => import('@page/troubleshooting/details'))
  },
  {
    path: 'notifications',
    component: asyncComponent(() => import('@page/notifications'))
  },
  {
    path: 'leads',
    component: asyncComponent(() => import('@page/leads'))
  },
  {
    path: 'leads/:session/edit',
    component: asyncComponent(() => import('@page/leads/edit'))
  },
  {
    path: 'leads/:session/convert',
    component: asyncComponent(() => import('@page/leads/convert'))
  },
  // {
  //   path: 'lead-assignment',
  //   component: asyncComponent(() => import('@page/lead-assignment/addEdit')),
  //   roles: ['FBB Operations', 'FBB Operations Lead', 'Tester']
  // },
  {
    path: 'assign-tasks',
    component: asyncComponent(() => import('@page/lead-assignment/addEdit'))
  },
  {
    path: 'unassigned-tasks',
    component: asyncComponent(() => import('@page/lead-assignment/list'))
  },
  {
    path: 'task-assign-upload',
    component: asyncComponent(() => import('@page/task-assign-upload/csv-upload'))
  },
  {
    path: 'assignment-config',
    component: asyncComponent(() => import('@page/assignment-config/addEdit'))
  },
  {
    path: 'tdc-csv',
    component: asyncComponent(() => import('@page/tdc/csv'))
  },
  //sim serial number
  {
    path: 'simserialnumbers',
    component: asyncComponent(() => import('@page/simSerialNumbers'))
  },
  {
    path: 'simserialnumbers/create',
    component: asyncComponent(() => import('@page/simSerialNumbers/addEdit'))
  },
  {
    path: 'sidebar-role-config',
    component: asyncComponent(() => import('@page/settings/sidebarOptionRoleConfig'))
  },
  {
    path: 'appointment-config',
    component: asyncComponent(() => import('@page/settings/appointmentProviderConfig'))
  },
  {
    path: 'wfm-file-upload',
    component: asyncComponent(() => import('@page/wfm-file-upload'))
  },
  {
    path: 'installers',
    component: asyncComponent(() => import('@page/installers'))
  },
  {
    path: 'installers/create',
    component: asyncComponent(() => import('@page/installers/addEdit'))
  },
  {
    path: 'installers/:installerId/edit',
    component: asyncComponent(() => import('@page/installers/addEdit'))
  },
  {
    path: 'installers/regions',
    component: asyncComponent(() => import('@page/installers/regions'))
  },
  {
    path: 'corporateApplications',
    component: asyncComponent(() => import('@page/corporateApplications'))
  },
  {
    path: 'corporateApplications/create',
    component: asyncComponent(() => import('@page/corporateApplications/addEdit'))
  },
  {
    path: 'corporateApplications/:session/edit',
    component: asyncComponent(() => import('@page/corporateApplications/addEdit'))
  },
  {
    path: 'internet-protocol',
    component: asyncComponent(() => import('@page/internet-protocol'))
  },
  {
    path: 'address-upload',
    component: asyncComponent(() => import('@page/address-upload'))
  },
  {
    path: 'saf-upload',
    component: asyncComponent(() => import('@page/marketing-ops/saf-upload'))
  },
  {
    path: 'serial-upload',
    component: asyncComponent(() => import('@page/marketing-ops/serial-upload'))
  },
  {
    path: 'reports/:reportId',
    component: asyncComponent(() => import('@page/reports'))
  },
  {
    path: 'promotions-config',
    component: asyncComponent(() => import('@page/promotions-config'))
  },
  {
    path: 'promotions-config/create',
    component: asyncComponent(() => import('@page/promotions-config/addEdit'))
  },
  {
    path: 'promotions-config/:promotionId/edit',
    component: asyncComponent(() => import('@page/promotions-config/addEdit'))
  },
  {
    path: 'data-extraction',
    component: asyncComponent(() => import('@page/data-extraction'))
  },
  {
    path: '*',
    component: asyncComponent(() => import('@page/common/404'))
  }
];

const getRolesForPath = (sidebarOptions, path) => {
    const item = sidebarOptions.find(option => option.path === path);        
    return item?.roles || [];
}

const FPFP_VIEW_ALLOWED_STATUSES = new Set(['VALIDATED', 'SUSPEND']);
const FPFP_CREATE_ALLOWED_STATUSES = new Set(['VALIDATED']);

const isFpfpViewRoute = (path) =>
  ['applications', 'applications-digi', 'applications-celcom', 'applications/:session/edit', 'celcom/:session/edit'].includes(
    path
  );

const isFpfpCreateRoute = (path) => ['applications/create', 'celcom/create'].includes(path);

function AppRouter(props) {
  const { url, style } = props;
  let userSetting = useSelector((state) => state.Auth.userSetting);
  const sidebarOptions = useSelector(state => state.SidebarMenu.sidebarOptions);
  const commonConfig = useSelector((state) => state.Auth.commonConfig || {});
  const userRoles = userSetting.roles || [];
  const userRolesIn = defineUserRoles(userRoles);
  const dealerStatus = userSetting.dealerStatus;
  const hasDealerStatus = Boolean(dealerStatus);

  const mergedRoutes = routes.map(route => {
    const dynamicRoles = getRolesForPath(sidebarOptions, route.path);
    let merged = dynamicRoles.length === 0 ? { ...route } : { ...route, roles: dynamicRoles };

    // When enableDealerValidation = false: skip validation completely.
    // When enableDealerValidation = true or not available: validate only if status exists.
    const shouldValidateDealerStatus = commonConfig.enableDealerValidation !== false && hasDealerStatus;
    const restrictedView =
      shouldValidateDealerStatus &&
      isFpfpViewRoute(merged.path) &&
      !FPFP_VIEW_ALLOWED_STATUSES.has(dealerStatus);
    const restrictedCreate =
      shouldValidateDealerStatus &&
      isFpfpCreateRoute(merged.path) &&
      !FPFP_CREATE_ALLOWED_STATUSES.has(dealerStatus);

    if (restrictedView || restrictedCreate) {
      merged = {
        ...merged,
        restrictedDealerStatus: dealerStatus || 'UNAVAILABLE'
      };
    }

    return merged;
  });
 
  // Filter routes if roles have been defined
  let allowRoutes = mergedRoutes.filter((route) => (route.roles ? userRolesIn(route.roles) : true));
  return (
    <div style={style}>
      <Switch>
        {allowRoutes.map((singleRoute) => {
          const { path, exact, restrictedDealerStatus, ...otherProps } = singleRoute;
          return restrictedDealerStatus ? (
            <Route
              exact={exact !== false}
              key={singleRoute.path}
              path={`${url}/${singleRoute.path}`}
              render={() => <StatusMessage description={`Your user status is ${restrictedDealerStatus}, can not proceed`} showBackButton={true} />}
            />
          ) : (
            <Route exact={exact !== false} key={singleRoute.path} path={`${url}/${singleRoute.path}`} {...otherProps} />
          );
        })}
      </Switch>
    </div>
  );
}

export default AppRouter;
